import {SampleDetails} from 'constants/SampleConstants';
import {readFragmentFromCache} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {graphQLToREST} from 'graphql-client/declarative-translations/external/translate';
import storableStore from 'samples/StorableStore';
import APIUtil from 'util/APIUtil';

import makeEmptySampleDetails from './makeEmptySampleDetails';
import {makeBoxSampleDetails, makeContainerSampleDetails, makePlateSampleDetails} from './makeSampleDetails';

/**
  Creates an array of SampleDetails from corresponding sample IDs.

  This function expects the sample details to already be present in the store. No data fetching
  will occur here! If a sample ID is not represented in the store, it will be filtered from
  the resulting array.

  Note: as this function relies solely on sample id, it cannot make WELL samples.
*/

export default function makeSampleDetailsFromSampleIds(sampleIds: Array<string>): Array<SampleDetails> {
  const samples: Array<SampleDetails> = [];

  for (const sampleId of sampleIds) {
    if (APIUtil.isBiologicalEntity(sampleId)) {
      const bioentitySummaryGql = readFragmentFromCache(getFragmentWrapper('BioentitySummary'), sampleId);
      if (bioentitySummaryGql != null) {
        const bioentitySummary = graphQLToREST('BioentitySummary', bioentitySummaryGql);
        samples.push({
          ...makeEmptySampleDetails(),
          bioentityInfo: {
            id: bioentitySummary.id,
            name: bioentitySummary.name,
            editURL: bioentitySummary.editURL,
          },
        });
      }
    }

    if (APIUtil.isBox(sampleId)) {
      const gridSummary = storableStore.getGridSummary(sampleId);
      if (gridSummary != null) {
        samples.push(makeBoxSampleDetails(gridSummary));
      }
    }

    if (APIUtil.isContainer(sampleId)) {
      const containerSummary = storableStore.getContainerSummary(sampleId);
      if (containerSummary != null) {
        samples.push(makeContainerSampleDetails(containerSummary));
      }
    }

    if (APIUtil.isPlate(sampleId)) {
      const gridSummary = storableStore.getGridSummary(sampleId);
      if (gridSummary != null) {
        samples.push(makePlateSampleDetails(gridSummary));
      }
    }
  }
  return samples;
}
